<template>
  <div
    class="page_container addEditBrandIncreasePage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/brandIndex/brandList' }"
          >合作品牌管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>合作品牌管理设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>合作品牌管理设置</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>品牌LOGO图片</p>
            <div
              class="upload_box"
              @mouseenter="creenIndex = 1"
              @mouseleave="creenIndex = ''"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.logo">
                  <img :src="formData.logo" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 1"
                  >
                    <span @click.stop="handlePictureCardPreview(formData.logo)"
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="formData.logo = ''"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>品牌名称：</p>
            <div class="input_box">
              <el-input
                v-model="formData.labelname"
                placeholder="品牌中文名称"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.labelcont_e"
                placeholder="Chinese brand name"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.labelcont_y"
                placeholder="Nhãn hiệu Tên Trung Quốc"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.labelcont_m"
                placeholder="ชื่อแบรนด์ ภาษาจีน"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.labelcont_t"
                placeholder="Nama tanda Cina"
              ></el-input>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>品牌状态：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.labelstate"
                style="justify-content: space-evenly"
              >
                <el-radio label="1">启用</el-radio>
                <el-radio
                  label="0"
                  :disabled="id != '' ? true : false"
                  checked-color="#ee0a24"
                  >停用
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  getBrandList,
  uploadImage,
  addBrand,
  editBrand,
  encryptstringview,
} from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "brandDetail",
  data() {
    return {
      qyid: 0,
      id: "",

      loading: false,
      formData: {
        qyguid: "",
        labelname: "",
        labelcont: "",
        sort: "",
        labelstate: "1",
        linkurl: "",
        apppath: "",
        logo: "",
        labelcont_e: "",
        labelcont_y: "",
        labelcont_m: "",
        labelcont_t: "",
        createman: "",
      },
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.formData.qyguid = USERINFO.qy.qyguid;
      this.qyid = USERINFO.qy.qyid;
    } else {
      this.formData.qyguid = 0;
      this.qyid = 0;
    }
    this.formData.createman = USERINFO.truename
      ? USERINFO.truename
      : USERINFO.nickname;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        if (id) {
          this.id = id;
          this.init(id);
        }
      } else {
        this.$router.back();
      }
    },

    init(id) {
      let { qyguid } = this.formData;
      this.loading = true;
      getBrandList({ qyguid }).then((res) => {
        let dataNew = res;
        let filter = dataNew.filter((v) => v.id == id);
        if (filter.length == 0) return;
        this.formData.labelname = filter[0].labelname
          ? filter[0].labelname
          : filter[0].labelcont;
        this.formData.labelcont = filter[0].labelcont;
        this.formData.sort = filter[0].sort;
        this.formData.labelstate = filter[0].labelstate
          ? filter[0].labelstate
          : 0;
        this.formData.logo = filter[0].logo;
        this.formData.linkurl = filter[0].linkurl;
        this.formData.apppath = filter[0].apppath;
        this.formData.labelcont_e = filter[0].labelcont_e;
        this.formData.labelcont_y = filter[0].labelcont_y;
        this.formData.labelcont_m = filter[0].labelcont_m;
        this.formData.labelcont_t = filter[0].labelcont_t;
        this.formData.createman = filter[0].createman;

        this.loading = false;
      });
    },

    handleReturn() {
      history.back();
    },

    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          this.formData.logo = res.url;
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    query() {
      let { formData, id } = this;
      if (formData.logo == "") {
        this.$message.warning("请上传品牌LOGO");
        return;
      }
      if (formData.labelname == "") {
        this.$message.warning("请输入品牌中文名称");
        return;
      }
      if (formData.labelstate == "" && formData.labelstate != 0) {
        this.$message.warning("请选择品牌状态");
        return;
      }
      if (id == "") {
        this.loading = true;
        addBrand(formData).then((res) => {
          if (res.result) {
            // this.$toast.success(res.message);
            // setTimeout(() => {
            //   // this.clearData();
            //   history.back();
            // }, 1500);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            // this.clearData();
            this.$message.error(res.message);
          }
        });
      } else {
        formData.id = id;
        this.loading = true;
        editBrand(formData).then((res) => {
          if (res.result) {
            // this.$toast.success(res.message);
            // setTimeout(() => {
            //   history.back();
            // }, 1500);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    clearData() {
      this.formData.labelname = "";
      this.formData.radio = "";
      this.formData.linkurl = "";
      this.formData.apppath = "";
      this.formData.labelstate = "";
      this.formData.labelcont_y = "";
      this.formData.labelcont_m = "";
      this.formData.labelcont_t = "";
      this.formData.logo = "";
      this.formData.sort = "";
    },
  },
};
</script>
<style lang="less" scoped>
.addEditBrandIncreasePage {
}
</style>